define('OutSystems/ClientRuntime/BuiltinFunctions',["require", "exports", "./ApplicationInfo", "./DataTypes", "./Injector", "./Injector/KnownServices", "./Navigation", "./RolesInfo", "./Settings"], function (require, exports, ApplicationInfo, DataTypes_1, Injector, KnownServices_1, Navigation, RolesInfo, Settings) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.iif = exports.getUserId = exports.getOwnerURLPath = exports.getBookmarkableURL = exports.getEntryEspaceName = exports.getUserAgent = exports.getCurrentLocale = exports.emailAddressValidate = exports.formatText = exports.formatPhoneNumber = exports.formatPercent = exports.formatDecimal = exports.formatCurrency = exports.formatDateTime = exports.toObject = exports.objectToDateTime = exports.objectToTime = exports.objectToDate = exports.objectToText = exports.objectToDecimal = exports.objectToBoolean = exports.objectToLongInteger = exports.objectToInteger = exports.textToIdentifier = exports.textToBoolean = exports.textToLongInteger = exports.textToLongIntegerValidate = exports.textToInteger = exports.textToIntegerValidate = exports.textToDecimal = exports.textToDecimalValidate = exports.timeToText = exports.textToTime = exports.textToTimeValidate = exports.textToDateTime = exports.textToDateTimeValidate = exports.textToDate = exports.textToDateValidate = exports.nullBinary = exports.nullObject = exports.nullDate = exports.nullTextIdentifier = exports.nullIdentifier = exports.integerToDecimal = exports.integerToText = exports.integerToBoolean = exports.integerToIdentifier = exports.integerToLongInteger = exports.identifierToText = exports.identifierToLongInteger = exports.identifierToInteger = exports.longIntegerToText = exports.longIntegerToIdentifier = exports.longIntegerToInteger = exports.longIntegerToIntegerValidate = exports.longIntegerToDecimal = exports.decimalToLongInteger = exports.decimalToLongIntegerValidate = exports.decimalToInteger = exports.decimalToIntegerValidate = exports.decimalToText = exports.decimalToBoolean = exports.dateToDateTime = exports.dateToText = exports.dateTimeToText = exports.dateTimeToTime = exports.dateTimeToDate = exports.booleanToText = exports.booleanToDecimal = exports.booleanToLongInteger = exports.booleanToInteger = exports.newTime = exports.newDateTime = exports.newDate = exports.second = exports.minute = exports.hour = exports.day = exports.month = exports.year = exports.diffSeconds = exports.diffMinutes = exports.diffHours = exports.diffDays = exports.dayOfWeek = exports.currTime = exports.currDateTime = exports.currDate = exports.buildDateTime = exports.addMonths = exports.addYears = exports.addSeconds = exports.addMinutes = exports.addHours = exports.addDays = exports.like = exports.trimEnd = exports.trimStart = exports.trim = exports.toUpper = exports.toLower = exports.substr = exports.replace = exports.length = exports.index = exports.encodeUrl = exports.encodeJavascript = exports.encodeHtml = exports.concat = exports.chr = exports.sign = exports.min = exports.max = exports.trunc = exports.sqrt = exports.round = exports.power = exports.mod = exports.abs = void 0;
    function parseDateFromRx(format) {
        if (format === void 0) { format = DataTypes_1.Constants.FORMAT.defaultDateTimeFormat; }
        return {
            year: parseInt(RegExp["$" + (format.yearIndexForDate + 1)], 10),
            month: parseInt(RegExp["$" + (format.monthIndexForDate + 1)], 10),
            day: parseInt(RegExp["$" + (format.dayIndexForDate + 1)], 10),
        };
    }
    function parseTimeFromRx(format) {
        if (format === void 0) { format = DataTypes_1.Constants.FORMAT.defaultDateTimeFormat; }
        var innerSeconds = parseInt(RegExp["$" + (format.secondsIndexForTime + 1)], 10);
        return {
            hours: parseInt(RegExp["$" + (format.hoursIndexForTime + 1)], 10),
            minutes: parseInt(RegExp["$" + (format.minutesIndexForTime + 1)], 10),
            seconds: isNaN(innerSeconds) ? 0 : innerSeconds,
        };
    }
    function parseDateTimeFromRx(format) {
        if (format === void 0) { format = DataTypes_1.Constants.FORMAT.defaultDateTimeFormat; }
        var innerSeconds = parseInt(RegExp["$" + (format.secondsIndexForDateTime + 1)], 10);
        return {
            year: parseInt(RegExp["$" + (format.yearIndexForDateTime + 1)], 10),
            month: parseInt(RegExp["$" + (format.monthIndexForDateTime + 1)], 10),
            day: parseInt(RegExp["$" + (format.dayIndexForDateTime + 1)], 10),
            hours: parseInt(RegExp["$" + (format.hoursIndexForDateTime + 1)], 10),
            minutes: parseInt(RegExp["$" + (format.minutesIndexForDateTime + 1)], 10),
            seconds: isNaN(innerSeconds) ? 0 : innerSeconds,
        };
    }
    function abs(n) {
        var result = n.abs();
        return result.isNaN() ? DataTypes_1.Constants.DEFAULT_DECIMAL : result;
    }
    exports.abs = abs;
    function mod(n, m) {
        var result = n.mod(m);
        return result.isNaN() ? DataTypes_1.Constants.DEFAULT_DECIMAL : result;
    }
    exports.mod = mod;
    function power(n, m) {
        var result = n.pow(m);
        return result.isNaN() ? DataTypes_1.Constants.DEFAULT_DECIMAL : result;
    }
    exports.power = power;
    function round(n, fractionalDigits) {
        if (fractionalDigits === void 0) { fractionalDigits = 0; }
        var result = n.toDecimalPlaces(fractionalDigits);
        return result.isNaN() ? DataTypes_1.Constants.DEFAULT_DECIMAL : result;
    }
    exports.round = round;
    function sqrt(n) {
        try {
            var result = n.sqrt();
            return result.isNaN() ? DataTypes_1.Constants.DEFAULT_DECIMAL : result;
        }
        catch (e) {
            return DataTypes_1.Constants.DEFAULT_DECIMAL;
        }
    }
    exports.sqrt = sqrt;
    function trunc(n) {
        var result = n.trunc();
        return result.isNaN() ? DataTypes_1.Constants.DEFAULT_DECIMAL : result;
    }
    exports.trunc = trunc;
    function max(n, m) {
        var result = DataTypes_1.Decimal.max(n, m);
        return result.isNaN() ? DataTypes_1.Constants.DEFAULT_DECIMAL : result;
    }
    exports.max = max;
    function min(n, m) {
        var result = DataTypes_1.Decimal.min(n, m);
        return result.isNaN() ? DataTypes_1.Constants.DEFAULT_DECIMAL : result;
    }
    exports.min = min;
    function sign(n) {
        var zero = new DataTypes_1.Decimal(0);
        if (n.eq(zero) || n.isNaN()) {
            return DataTypes_1.Constants.DEFAULT_INTEGER;
        }
        return n > zero ? 1 : -1;
    }
    exports.sign = sign;
    function chr(c) {
        var maxChr = 0xffff;
        var minChr = 0;
        return c >= minChr && c <= maxChr ? String.fromCharCode(c) : DataTypes_1.Constants.DEFAULT_TEXT;
    }
    exports.chr = chr;
    function concat(text1, text2) {
        return (text1 || "") + (text2 || "");
    }
    exports.concat = concat;
    function fixHtmlSpaces(s) {
        if (s === undefined || s === "") {
            return s;
        }
        var chars = [];
        var spaceCharCode = " ".charCodeAt(0);
        var newLineCharCode = "\n".charCodeAt(0);
        var xA0char = "\xA0";
        if (s.charCodeAt(0) === spaceCharCode) {
            chars[0] = xA0char;
        }
        else {
            chars[0] = s.charAt(0);
        }
        for (var i = 1; i < s.length - 1; ++i) {
            if (s.charCodeAt(i) === spaceCharCode &&
                (s.charCodeAt(i - 1) === newLineCharCode || s.charCodeAt(i + 1) === spaceCharCode)) {
                chars[i] = xA0char;
            }
            else {
                chars[i] = s.charAt(i);
            }
        }
        if (s.length !== 1) {
            if (s.charCodeAt(s.length - 1) === spaceCharCode) {
                chars[s.length - 1] = xA0char;
            }
            else {
                chars[s.length - 1] = s.charAt(s.length - 1);
            }
        }
        return chars.join("");
    }
    function encode(text) {
        var buf = [];
        for (var i = 0; i < text.length; ++i) {
            var c = text.charCodeAt(i);
            if (c === 60) {
                buf.push("&lt;");
            }
            else if (c === 62) {
                buf.push("&gt;");
            }
            else if (c === 38) {
                buf.push("&amp;");
            }
            else if (c === 34) {
                buf.push("&quot;");
            }
            else if (c === 39) {
                buf.push("&#39;");
            }
            else if (c >= 160 && c <= 255) {
                buf.push("&#" + c + ";");
            }
            else {
                buf.push(text.charAt(i));
            }
        }
        return buf.join("");
    }
    function encodeHtml(text) {
        if (text === undefined) {
            return "";
        }
        return fixHtmlSpaces(encode(text))
            .replace(/\r/g, "")
            .replace(/&#13;/g, "")
            .replace(/\n/g, "<br/>")
            .replace(/&#10;/g, "<br/>");
    }
    exports.encodeHtml = encodeHtml;
    function encodeJavascript(text) {
        return text
            .replace(/\\/g, "\\x5c")
            .replace(/'/g, "\\x27")
            .replace(/\"/g, "\\x22")
            .replace("&", "\\x26")
            .replace("<", "\\x3c")
            .replace(/>/g, "\\x3e")
            .replace(/\r/g, "\\r")
            .replace(/\n/g, "\\n");
    }
    exports.encodeJavascript = encodeJavascript;
    function encodeUrl(text) {
        return encodeURIComponent(text).replace(/'/g, "%27").replace(/%20/g, "+");
    }
    exports.encodeUrl = encodeUrl;
    var SURROGATE_PAIRS = "[".concat(String.fromCharCode(0xd800), "-").concat(String.fromCharCode(0xdbff), "]");
    var SURROGATE_PAIRS_REGEXP = new RegExp(SURROGATE_PAIRS, "g");
    function index(t, s, startIndex, searchFromEnd, ignoreCase) {
        try {
            if (s.length === 0 || startIndex < 0 || startIndex > length(t)) {
                return -1;
            }
            if (ignoreCase) {
                t = t.toLocaleLowerCase();
                s = s.toLocaleLowerCase();
            }
            if (startIndex > 0) {
                var matchResult = t.match(new RegExp("(" + SURROGATE_PAIRS + ".|[\\s\\S]){" + startIndex + "}"));
                if (matchResult) {
                    startIndex = matchResult[0].length;
                }
                else {
                    return -1;
                }
            }
            var index_1 = searchFromEnd ? t.lastIndexOf(s, startIndex || t.length) : t.indexOf(s, startIndex || 0);
            if (index_1 < 0) {
                return -1;
            }
            return length(t.substring(0, index_1));
        }
        catch (e) {
            return -1;
        }
    }
    exports.index = index;
    function length(t) {
        var surrogatePairs = t.match(SURROGATE_PAIRS_REGEXP);
        return t.length - (surrogatePairs ? surrogatePairs.length : 0);
    }
    exports.length = length;
    function replace(t, r, s) {
        var escapedRegExp = r.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return t.replace(new RegExp(escapedRegExp, "g"), s);
    }
    exports.replace = replace;
    function substr(text, start, len) {
        var lengthToReplace = length(text);
        if (start >= 0 && len > 0 && lengthToReplace >= start + 1) {
            lengthToReplace = Math.min(lengthToReplace, len);
        }
        else if (start >= 0 && len > 0 && lengthToReplace > start) {
            lengthToReplace = lengthToReplace - start;
        }
        else {
            return DataTypes_1.Constants.DEFAULT_TEXT;
        }
        var hasSurrogatePairs = text.match(SURROGATE_PAIRS_REGEXP);
        return hasSurrogatePairs
            ? text.match(new RegExp("(" +
                SURROGATE_PAIRS +
                ".|[\\s\\S]){" +
                start +
                "}((" +
                SURROGATE_PAIRS +
                ".|[\\s\\S]){" +
                lengthToReplace +
                "})"))[2]
            : text.substring(start, start + lengthToReplace);
    }
    exports.substr = substr;
    function toLower(t) {
        return t.toLowerCase();
    }
    exports.toLower = toLower;
    function toUpper(t) {
        return t.toUpperCase();
    }
    exports.toUpper = toUpper;
    function trim(t) {
        return t.trim();
    }
    exports.trim = trim;
    function trimStart(t) {
        var startIndex = 0;
        var character = " ";
        while (t[startIndex] === character) {
            startIndex++;
        }
        return t.substring(startIndex);
    }
    exports.trimStart = trimStart;
    function trimEnd(t) {
        var endIndex = t.length - 1;
        var character = " ";
        while (t[endIndex] === character) {
            endIndex--;
        }
        return t.substring(0, endIndex + 1);
    }
    exports.trimEnd = trimEnd;
    function like(str, searchPattern) {
        if (!searchPattern) {
            return false;
        }
        var regexPattern = searchPattern
            .replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&")
            .replace(/%/g, ".*")
            .replace(/_/g, ".");
        return RegExp("^".concat(regexPattern, "$"), "gi").test(str);
    }
    exports.like = like;
    function addDays(value, daysToAdd) {
        return value.addDays(daysToAdd);
    }
    exports.addDays = addDays;
    function addHours(value, hoursToAdd) {
        return value.addHours(hoursToAdd);
    }
    exports.addHours = addHours;
    function addMinutes(value, minutesToAdd) {
        return value.addMinutes(minutesToAdd);
    }
    exports.addMinutes = addMinutes;
    function addSeconds(value, secondsToAdd) {
        return value.addSeconds(secondsToAdd);
    }
    exports.addSeconds = addSeconds;
    function addYears(value, yearsToAdd) {
        return value.addYears(yearsToAdd);
    }
    exports.addYears = addYears;
    function addMonths(value, monthsToAdd) {
        return value.addMonths(monthsToAdd);
    }
    exports.addMonths = addMonths;
    function buildDateTime(value, timeValue) {
        return new DataTypes_1.DateTime(value.year, value.month, value.day, timeValue.hours, timeValue.minutes, timeValue.seconds, timeValue.milliseconds);
    }
    exports.buildDateTime = buildDateTime;
    function currDate() {
        var dateTime = new DataTypes_1.DateTime(new Date());
        return new DataTypes_1.DateTime(dateTime.year, dateTime.month, dateTime.day);
    }
    exports.currDate = currDate;
    function currDateTime() {
        return new DataTypes_1.DateTime(new Date());
    }
    exports.currDateTime = currDateTime;
    function currTime() {
        var dateTime = new DataTypes_1.DateTime(new Date());
        return new DataTypes_1.DateTime(1900, 1, 1, dateTime.hours, dateTime.minutes, dateTime.seconds);
    }
    exports.currTime = currTime;
    function dayOfWeek(dateValue) {
        return dateValue.weekDay;
    }
    exports.dayOfWeek = dayOfWeek;
    function toMilisecondsWithTimezoneOffset(date) {
        var dateWithTimezone = new Date(date.getTime());
        dateWithTimezone.setMinutes(date.getMinutes() - date.getTimezoneOffset());
        return dateWithTimezone.getTime();
    }
    function diff(dt, dt2, divider, useTimeZoneOffset) {
        if (useTimeZoneOffset === void 0) { useTimeZoneOffset = false; }
        var useHours = divider <= 3600000;
        var useMinutes = divider <= 60000;
        var useSeconds = divider <= 1000;
        var dtNative = fixTimePart(dt, useHours, useMinutes, useSeconds).toNative();
        var dt2Native = fixTimePart(dt2, useHours, useMinutes, useSeconds).toNative();
        var d = Date.UTC(dtNative.getUTCFullYear(), dtNative.getUTCMonth(), dtNative.getUTCDate(), dtNative.getUTCHours(), dtNative.getUTCMinutes(), dtNative.getUTCSeconds(), 0);
        var d2 = Date.UTC(dt2Native.getUTCFullYear(), dt2Native.getUTCMonth(), dt2Native.getUTCDate(), dt2Native.getUTCHours(), dt2Native.getUTCMinutes(), dt2Native.getUTCSeconds(), 0);
        var ms = useTimeZoneOffset
            ? toMilisecondsWithTimezoneOffset(dt2Native) - toMilisecondsWithTimezoneOffset(dtNative)
            : d2 - d;
        return Math.floor(ms / divider);
    }
    function fixTimePart(dt, useHours, useMinutes, useSeconds) {
        return new DataTypes_1.DateTime(dt.year, dt.month, dt.day, useHours ? dt.hours : 0, useMinutes ? dt.minutes : 0, useSeconds ? dt.seconds : 0);
    }
    function diffDays(dt, dt2) {
        return diff(dt, dt2, 86400000, true);
    }
    exports.diffDays = diffDays;
    function diffHours(dt, dt2) {
        return diff(dt, dt2, 3600000);
    }
    exports.diffHours = diffHours;
    function diffMinutes(dt, dt2) {
        return diff(dt, dt2, 60000);
    }
    exports.diffMinutes = diffMinutes;
    function diffSeconds(dt, dt2) {
        return diff(dt, dt2, 1000);
    }
    exports.diffSeconds = diffSeconds;
    function year(dateValue) {
        return dateValue.year;
    }
    exports.year = year;
    function month(dateValue) {
        return dateValue.month;
    }
    exports.month = month;
    function day(dateValue) {
        return dateValue.day;
    }
    exports.day = day;
    function hour(dateValue) {
        return dateValue.hours;
    }
    exports.hour = hour;
    function minute(dateValue) {
        return dateValue.minutes;
    }
    exports.minute = minute;
    function second(dateValue) {
        return dateValue.seconds;
    }
    exports.second = second;
    function newDate(y, mo, d) {
        if (validateDate(y, mo, d)) {
            return new DataTypes_1.DateTime(y, mo, d);
        }
        return DataTypes_1.Constants.DEFAULT_DATE;
    }
    exports.newDate = newDate;
    function newDateTime(y, mo, d, h, mi, s) {
        if (validateDateTime(y, mo, d, h, mi, s)) {
            return new DataTypes_1.DateTime(y, mo, d, h, mi, s);
        }
        return DataTypes_1.Constants.DEFAULT_DATETIME;
    }
    exports.newDateTime = newDateTime;
    function newTime(h, mi, s) {
        if (validateTime(h, mi, s)) {
            return new DataTypes_1.DateTime(1900, 1, 1, h, mi, s);
        }
        return DataTypes_1.Constants.DEFAULT_TIME;
    }
    exports.newTime = newTime;
    function validateTime(hours, minutes, seconds) {
        var time = new DataTypes_1.DateTime(1900, 1, 1, hours, minutes, seconds);
        return time.hours === hours && time.minutes === minutes && time.seconds === seconds;
    }
    function validateDate(year, month, day) {
        var dateTime = new DataTypes_1.DateTime(year, month, day);
        return dateTime.year === year && dateTime.month === month && dateTime.day === day;
    }
    function validateDateTime(year, month, day, hours, minutes, seconds) {
        var dateTime = new DataTypes_1.DateTime(year, month, day, hours, minutes, seconds);
        return (dateTime.year === year &&
            dateTime.month === month &&
            dateTime.day === day &&
            dateTime.hours === hours &&
            dateTime.minutes === minutes &&
            dateTime.seconds === seconds);
    }
    function booleanToInteger(value) {
        return value ? 1 : 0;
    }
    exports.booleanToInteger = booleanToInteger;
    function booleanToLongInteger(value) {
        return value ? DataTypes_1.LongInteger.fromNumber(1) : DataTypes_1.LongInteger.fromNumber(0);
    }
    exports.booleanToLongInteger = booleanToLongInteger;
    function booleanToDecimal(value) {
        return new DataTypes_1.Decimal(value ? 1 : 0);
    }
    exports.booleanToDecimal = booleanToDecimal;
    function booleanToText(value) {
        if (value === true) {
            return "True";
        }
        else if (value === false) {
            return "False";
        }
        else {
            return DataTypes_1.Constants.DEFAULT_TEXT;
        }
    }
    exports.booleanToText = booleanToText;
    function dateTimeToDate(value) {
        return new DataTypes_1.DateTime(value.year, value.month, value.day);
    }
    exports.dateTimeToDate = dateTimeToDate;
    function dateTimeToTime(value) {
        return new DataTypes_1.DateTime(1900, 1, 1, value.hours, value.minutes, value.seconds);
    }
    exports.dateTimeToTime = dateTimeToTime;
    function dateTimeToText(value) {
        return value.toString(DataTypes_1.Constants.FORMAT.defaultDateTimeFormat.dateTimeFormat);
    }
    exports.dateTimeToText = dateTimeToText;
    function dateToText(value) {
        return value.toString(DataTypes_1.Constants.FORMAT.defaultDateTimeFormat.dateFormat);
    }
    exports.dateToText = dateToText;
    function dateToDateTime(value) {
        return value;
    }
    exports.dateToDateTime = dateToDateTime;
    function decimalToBoolean(d) {
        return !d.eq(new DataTypes_1.Decimal(0.0));
    }
    exports.decimalToBoolean = decimalToBoolean;
    function decimalToText(value) {
        return DataTypes_1.TypeValidations.isValidDecimal(value) ? value.toString() : DataTypes_1.Constants.DEFAULT_TEXT;
    }
    exports.decimalToText = decimalToText;
    function decimalToIntegerValidate(value) {
        return value.gte(DataTypes_1.Constants.MIN_INTEGER_VALUE) && value.lte(DataTypes_1.Constants.MAX_INTEGER_VALUE);
    }
    exports.decimalToIntegerValidate = decimalToIntegerValidate;
    function decimalToInteger(value) {
        if (!decimalToIntegerValidate(value)) {
            return DataTypes_1.Constants.DEFAULT_INTEGER;
        }
        return value.round().toNumber();
    }
    exports.decimalToInteger = decimalToInteger;
    function decimalToLongIntegerValidate(value) {
        return (value.gte(DataTypes_1.Constants.MIN_LONGINTEGER_VALUE.toString()) && value.lte(DataTypes_1.Constants.MAX_LONGINTEGER_VALUE.toString()));
    }
    exports.decimalToLongIntegerValidate = decimalToLongIntegerValidate;
    function decimalToLongInteger(value) {
        if (!decimalToLongIntegerValidate(value)) {
            return DataTypes_1.Constants.DEFAULT_LONGINTEGER;
        }
        return DataTypes_1.LongInteger.fromString(value.round().toString());
    }
    exports.decimalToLongInteger = decimalToLongInteger;
    function longIntegerToDecimal(value) {
        return new DataTypes_1.Decimal(value.toString());
    }
    exports.longIntegerToDecimal = longIntegerToDecimal;
    function longIntegerToIntegerValidate(value) {
        return DataTypes_1.TypeValidations.isWithinIntegerRange(value.toNumber());
    }
    exports.longIntegerToIntegerValidate = longIntegerToIntegerValidate;
    function longIntegerToInteger(value) {
        var num = value.toNumber();
        if (!DataTypes_1.TypeValidations.isWithinIntegerRange(num)) {
            return DataTypes_1.Constants.DEFAULT_INTEGER;
        }
        return num;
    }
    exports.longIntegerToInteger = longIntegerToInteger;
    function longIntegerToIdentifier(value) {
        return value;
    }
    exports.longIntegerToIdentifier = longIntegerToIdentifier;
    function longIntegerToText(value) {
        return DataTypes_1.TypeValidations.isValidLongInteger(value) ? value.toString() : DataTypes_1.Constants.DEFAULT_TEXT;
    }
    exports.longIntegerToText = longIntegerToText;
    function identifierToInteger(er) {
        return er;
    }
    exports.identifierToInteger = identifierToInteger;
    function identifierToLongInteger(value) {
        return value;
    }
    exports.identifierToLongInteger = identifierToLongInteger;
    function identifierToText(ert) {
        return ert;
    }
    exports.identifierToText = identifierToText;
    function integerToLongInteger(value) {
        return DataTypes_1.LongInteger.fromNumber(value);
    }
    exports.integerToLongInteger = integerToLongInteger;
    function integerToIdentifier(i) {
        return i;
    }
    exports.integerToIdentifier = integerToIdentifier;
    function integerToBoolean(i) {
        return i !== 0;
    }
    exports.integerToBoolean = integerToBoolean;
    function integerToText(value) {
        return DataTypes_1.TypeValidations.isValidInteger(value) ? value.toString() : DataTypes_1.Constants.DEFAULT_TEXT;
    }
    exports.integerToText = integerToText;
    function integerToDecimal(value) {
        return new DataTypes_1.Decimal(value);
    }
    exports.integerToDecimal = integerToDecimal;
    function nullIdentifier() {
        return 0;
    }
    exports.nullIdentifier = nullIdentifier;
    function nullTextIdentifier() {
        return "";
    }
    exports.nullTextIdentifier = nullTextIdentifier;
    function nullDate() {
        return DataTypes_1.Constants.DEFAULT_DATE;
    }
    exports.nullDate = nullDate;
    function nullObject() {
        return null;
    }
    exports.nullObject = nullObject;
    function nullBinary() {
        return DataTypes_1.Constants.DEFAULT_BINARYDATA;
    }
    exports.nullBinary = nullBinary;
    function internalTextToDateValidate(value, format) {
        var valid = format.getRegExpForDate().test(value);
        if (valid) {
            var input = parseDateFromRx(format);
            var date = new DataTypes_1.DateTime(input.year, input.month, input.day);
            valid = date.year === input.year && date.month === input.month && date.day === input.day;
        }
        return valid;
    }
    function internalTextToDate(value, format) {
        if (!internalTextToDateValidate(value, format)) {
            return DataTypes_1.DateTime.defaultValue;
        }
        format.getRegExpForDate().test(value);
        var input = parseDateFromRx(format);
        return new DataTypes_1.DateTime(input.year, input.month, input.day);
    }
    function internalTextToDateTimeValidate(value, format) {
        var valid = format.getRegExpForDateTime().test(value);
        if (valid) {
            var input = parseDateTimeFromRx(format);
            valid = validateDateTime(input.year, input.month, input.day, input.hours, input.minutes, input.seconds);
        }
        return valid;
    }
    function internalTextToDateTime(value, format) {
        if (!internalTextToDateTimeValidate(value, format)) {
            return DataTypes_1.DateTime.defaultValue;
        }
        var input = parseDateTimeFromRx(format);
        return new DataTypes_1.DateTime(input.year, input.month, input.day, input.hours, input.minutes, input.seconds);
    }
    function isISODateTime(value) {
        return value.toUpperCase().indexOf("T") !== -1;
    }
    function isSpaceSeparatedDateTime(value) {
        return value.indexOf(" ") !== -1;
    }
    function getDateFromDateTime(value) {
        var splitPos = value.toUpperCase().search("T| ");
        if (splitPos !== -1) {
            value = value.substring(0, splitPos);
        }
        return value;
    }
    function textToDateValidate(value) {
        var acceptable = DataTypes_1.Constants.FORMAT.dateTimeFormats;
        value = getDateFromDateTime(value);
        for (var dateInd = 0; dateInd < acceptable.length; ++dateInd) {
            if (internalTextToDateValidate(value, acceptable[dateInd])) {
                return true;
            }
        }
        return false;
    }
    exports.textToDateValidate = textToDateValidate;
    function textToDate(value) {
        var acceptable = DataTypes_1.Constants.FORMAT.dateTimeFormats;
        value = getDateFromDateTime(value);
        for (var dateInd = 0; dateInd < acceptable.length; ++dateInd) {
            var textConverted = internalTextToDate(value, acceptable[dateInd]);
            if (!textConverted.eq(DataTypes_1.DateTime.defaultValue)) {
                return textConverted;
            }
        }
        return DataTypes_1.DateTime.defaultValue;
    }
    exports.textToDate = textToDate;
    function ISODateTimeValidate(value) {
        if (isISODateTime(value)) {
            return !isNaN(Date.parse(value));
        }
        else {
            return true;
        }
    }
    function textToDateTimeValidate(value) {
        var acceptable = DataTypes_1.Constants.FORMAT.dateTimeFormats;
        if (isISODateTime(value)) {
            return ISODateTimeValidate(value);
        }
        if (!isSpaceSeparatedDateTime(value)) {
            value += " 00:00:00";
        }
        for (var dateInd = 0; dateInd < acceptable.length; ++dateInd) {
            if (internalTextToDateTimeValidate(value, acceptable[dateInd])) {
                return true;
            }
        }
        return false;
    }
    exports.textToDateTimeValidate = textToDateTimeValidate;
    function textToDateTime(value) {
        var acceptable = DataTypes_1.Constants.FORMAT.dateTimeFormats;
        if (isISODateTime(value)) {
            return DataTypes_1.DateTime.fromISODateTime(value);
        }
        if (!isSpaceSeparatedDateTime(value)) {
            value += " 00:00:00";
        }
        for (var dateInd = 0; dateInd < acceptable.length; ++dateInd) {
            var textConverted = internalTextToDateTime(value, acceptable[dateInd]);
            if (!textConverted.eq(DataTypes_1.DateTime.defaultValue)) {
                return textConverted;
            }
        }
        return DataTypes_1.DateTime.defaultValue;
    }
    exports.textToDateTime = textToDateTime;
    function getTimeFromSpaceSeparatedDateTime(value) {
        var splitPos = value.indexOf(" ");
        if (splitPos !== -1) {
            value = value.substring(splitPos + 1, value.length);
        }
        return value;
    }
    function textToTimeValidate(value, format) {
        if (format === void 0) { format = DataTypes_1.Constants.FORMAT.defaultDateTimeFormat; }
        if (isISODateTime(value)) {
            return ISODateTimeValidate(value);
        }
        if (isSpaceSeparatedDateTime(value)) {
            value = getTimeFromSpaceSeparatedDateTime(value);
        }
        var valid = format.getRegExpForTime().test(value);
        if (valid) {
            var input = parseTimeFromRx(format);
            valid = validateTime(input.hours, input.minutes, input.seconds);
        }
        return valid;
    }
    exports.textToTimeValidate = textToTimeValidate;
    function textToTime(value) {
        if (isISODateTime(value)) {
            var dateTime = DataTypes_1.DateTime.fromISODateTime(value);
            return new DataTypes_1.DateTime(1900, 1, 1, dateTime.hours, dateTime.minutes, dateTime.seconds, dateTime.milliseconds);
        }
        if (isSpaceSeparatedDateTime(value)) {
            value = getTimeFromSpaceSeparatedDateTime(value);
        }
        return internalTextToTime(value, DataTypes_1.Constants.FORMAT.defaultDateTimeFormat);
    }
    exports.textToTime = textToTime;
    function internalTextToTime(value, format) {
        if (!textToTimeValidate(value, format)) {
            return DataTypes_1.DateTime.defaultValue;
        }
        format.getRegExpForTime().test(value);
        var input = parseTimeFromRx(format);
        return new DataTypes_1.DateTime(1900, 1, 1, input.hours, input.minutes, input.seconds);
    }
    function timeToText(value) {
        return value.toString(DataTypes_1.Constants.FORMAT.defaultDateTimeFormat.timeFormat);
    }
    exports.timeToText = timeToText;
    function tryParseInteger(value) {
        if (DataTypes_1.Constants.FORMAT.numberFormat.getRegExpForInteger().test(value)) {
            var intValue = parseInt(value, 10);
            if (!isNaN(intValue) && intValue >= DataTypes_1.Constants.MIN_INTEGER_VALUE && intValue <= DataTypes_1.Constants.MAX_INTEGER_VALUE) {
                return intValue;
            }
        }
        return null;
    }
    function tryParseDecimal(value) {
        if (DataTypes_1.Constants.FORMAT.numberFormat.getRegExpForDecimal().test(value)) {
            var decValue = new DataTypes_1.Decimal(value);
            if (!decValue.isNaN() &&
                decValue.gte(DataTypes_1.Constants.MIN_DECIMAL_VALUE) &&
                decValue.lte(DataTypes_1.Constants.MAX_DECIMAL_VALUE)) {
                return decValue;
            }
        }
        return null;
    }
    function tryParseLongInteger(value) {
        if (!DataTypes_1.Constants.FORMAT.numberFormat.getRegExpForInteger().test(value)) {
            return null;
        }
        var isNegativeNumber = value.charAt(0) === "-";
        if ((isNegativeNumber && value.length < DataTypes_1.Constants.MIN_LONGINTEGER_VALUE.toString().length) ||
            (!isNegativeNumber && value.length < DataTypes_1.Constants.MAX_LONGINTEGER_VALUE.toString().length) ||
            decimalToLongIntegerValidate(new DataTypes_1.Decimal(value))) {
            try {
                return DataTypes_1.LongInteger.fromString(value);
            }
            catch (e) {
            }
        }
        return null;
    }
    function textToDecimalValidate(value) {
        return tryParseDecimal(value) !== null;
    }
    exports.textToDecimalValidate = textToDecimalValidate;
    function textToDecimal(value) {
        var decimal = tryParseDecimal(value);
        if (decimal === null) {
            return DataTypes_1.Constants.DEFAULT_DECIMAL;
        }
        return new DataTypes_1.Decimal(value);
    }
    exports.textToDecimal = textToDecimal;
    function textToIntegerValidate(value) {
        return tryParseInteger(value) !== null;
    }
    exports.textToIntegerValidate = textToIntegerValidate;
    function textToInteger(value) {
        var integer = tryParseInteger(value);
        if (integer === null) {
            return DataTypes_1.Constants.DEFAULT_INTEGER;
        }
        return integer;
    }
    exports.textToInteger = textToInteger;
    function textToLongIntegerValidate(value) {
        return tryParseLongInteger(value) !== null;
    }
    exports.textToLongIntegerValidate = textToLongIntegerValidate;
    function textToLongInteger(value) {
        var long = tryParseLongInteger(value);
        if (long === null) {
            return DataTypes_1.Constants.DEFAULT_LONGINTEGER;
        }
        return long;
    }
    exports.textToLongInteger = textToLongInteger;
    function textToBoolean(value) {
        return value.toLowerCase() === "true";
    }
    exports.textToBoolean = textToBoolean;
    function textToIdentifier(t) {
        return t;
    }
    exports.textToIdentifier = textToIdentifier;
    function objectToInteger(value) {
        if (typeof value === "number" || DataTypes_1.TypeValidations.isLongInteger(value) || DataTypes_1.TypeValidations.isDecimal(value)) {
            return new DataTypes_1.Decimal(value.toString()).round().toNumber();
        }
        throw new TypeError("Cannot convert type '" + typeof value + "' to 'Integer'");
    }
    exports.objectToInteger = objectToInteger;
    function objectToLongInteger(value) {
        if (typeof value === "number" || DataTypes_1.TypeValidations.isLongInteger(value) || DataTypes_1.TypeValidations.isDecimal(value)) {
            return DataTypes_1.LongInteger.fromString(new DataTypes_1.Decimal(value.toString()).round().toString());
        }
        throw new TypeError("Cannot convert type '" + typeof value + "' to 'LongInteger'");
    }
    exports.objectToLongInteger = objectToLongInteger;
    function objectToBoolean(value) {
        if (typeof value === "boolean") {
            return value;
        }
        throw new TypeError("Cannot convert type '" + typeof value + "' to 'Boolean'");
    }
    exports.objectToBoolean = objectToBoolean;
    function objectToDecimal(value) {
        if (typeof value === "number" || DataTypes_1.TypeValidations.isLongInteger(value) || DataTypes_1.TypeValidations.isDecimal(value)) {
            return new DataTypes_1.Decimal(value.toString());
        }
        throw new TypeError("Cannot convert type '" + typeof value + "' to 'Decimal'");
    }
    exports.objectToDecimal = objectToDecimal;
    function objectToText(value) {
        if (typeof value === "string") {
            return value;
        }
        throw new TypeError("Cannot convert type '" + typeof value + "' to 'Text'");
    }
    exports.objectToText = objectToText;
    function objectToDate(value) {
        return convertObjectToDateTime(value, true, false);
    }
    exports.objectToDate = objectToDate;
    function objectToTime(value) {
        return convertObjectToDateTime(value, false, true);
    }
    exports.objectToTime = objectToTime;
    function objectToDateTime(value) {
        return convertObjectToDateTime(value, true, true);
    }
    exports.objectToDateTime = objectToDateTime;
    function convertObjectToDateTime(value, hasDate, hasTime) {
        if (value instanceof DataTypes_1.DateTime || Object.prototype.toString.call(value) === "[object Date]") {
            var dateTime = new DataTypes_1.DateTime(value.getTime());
            var year_1 = hasDate ? dateTime.year : 1900;
            var month_1 = hasDate ? dateTime.month : 1;
            var days = hasDate ? dateTime.day : 1;
            var hours = hasTime ? dateTime.hours : 0;
            var minutes = hasTime ? dateTime.minutes : 0;
            var seconds = hasTime ? dateTime.seconds : 0;
            return new DataTypes_1.DateTime(year_1, month_1, days, hours, minutes, seconds);
        }
        throw new TypeError("Cannot convert type '" + typeof value + "' to 'DateTime'");
    }
    function toObject(value) {
        return value;
    }
    exports.toObject = toObject;
    function formatDateTime(dateValue, format) {
        return dateValue.toString(format);
    }
    exports.formatDateTime = formatDateTime;
    function formatCurrency(currencyValue, currencySymbol, decimalDigits, decimalSeparator, groupSeparator) {
        var decimalAsText = formatDecimal(currencyValue, decimalDigits, decimalSeparator, groupSeparator);
        return decimalAsText === DataTypes_1.Constants.DEFAULT_TEXT ? DataTypes_1.Constants.DEFAULT_TEXT : currencySymbol + decimalAsText;
    }
    exports.formatCurrency = formatCurrency;
    function formatDecimal(decimalValue, decimalDigits, decimalSeparator, groupSeparator) {
        if (decimalDigits < 0) {
            return DataTypes_1.Constants.DEFAULT_TEXT;
        }
        if (decimalSeparator.length > 1) {
            decimalSeparator = decimalSeparator.substring(0, 1);
        }
        if (groupSeparator.length > 1) {
            groupSeparator = groupSeparator.substring(0, 1);
        }
        return decimalValue.toFormat(decimalDigits, DataTypes_1.Decimal.rounding, {
            decimalSeparator: decimalSeparator,
            groupSeparator: groupSeparator,
        });
    }
    exports.formatDecimal = formatDecimal;
    function formatPercent(value, decimal_digits, decimal_separator) {
        try {
            if (decimal_digits < 0) {
                return "";
            }
            if (decimal_separator.length > 1) {
                decimal_separator = decimal_separator.substring(0, 1);
            }
            return (value.times(100).toFormat(decimal_digits, DataTypes_1.Decimal.rounding, {
                decimalSeparator: decimal_separator,
                groupSeparator: "",
            }) + "%");
        }
        catch (e) {
            return "";
        }
    }
    exports.formatPercent = formatPercent;
    function formatPhoneNumber(val, int_code_digits, area_code_digits, phone_digits, int_separator, area_separator, phone_separator) {
        try {
            if (!/^\d+$/.test(val)) {
                return val;
            }
            if (val.length !== int_code_digits + area_code_digits + phone_digits) {
                return val;
            }
            return (int_separator +
                val.substring(0, int_code_digits) +
                area_separator +
                val.substring(int_code_digits, int_code_digits + area_code_digits) +
                phone_separator +
                val.substring(int_code_digits + area_code_digits, int_code_digits + area_code_digits + phone_digits));
        }
        catch (e) {
            return "";
        }
    }
    exports.formatPhoneNumber = formatPhoneNumber;
    function formatText(val, min_chars, max_chars, left_padding, padding_char) {
        try {
            var len = length(val);
            if (len < min_chars) {
                padding_char = substr(padding_char, 0, 1);
                var missingLength = min_chars - len;
                while (missingLength-- > 0) {
                    if (left_padding) {
                        val = padding_char + val;
                    }
                    else {
                        val = val + padding_char;
                    }
                }
                return val;
            }
            if (len > max_chars) {
                if (left_padding) {
                    return substr(val, len - max_chars, max_chars);
                }
                else {
                    return substr(val, 0, max_chars);
                }
            }
            return val;
        }
        catch (e) {
            return "";
        }
    }
    exports.formatText = formatText;
    var emailRegexStr = "[a-zA-Z0-9.!#$%&'*+\\-/=?^_`{|}~]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*";
    var emailNameStr = "([0-9a-zA-Z\\\\= ]*|=\\?([^?]*)\\?([qQbB])\\?([^?]*)\\?=)";
    var simpleEmailRegex = new RegExp("^" + emailRegexStr + "$");
    var nameAndEmailRegex = new RegExp("^" + emailNameStr + "[ ]*<" + emailRegexStr + ">$");
    var quotedNameAndEmailRegex = new RegExp('^\\"' + emailNameStr + '\\"[ ]*<' + emailRegexStr + ">$");
    var invalidEmailPatterns = Settings.getEnvParams().AllowTwoSequentialDotsInEmail ? [".@"] : [".@", ".."];
    function internalEmailIsValid(email) {
        if (email === "") {
            return true;
        }
        if (invalidEmailPatterns.some(function (p) { return email.indexOf(p) !== -1; })) {
            return false;
        }
        return simpleEmailRegex.test(email) || nameAndEmailRegex.test(email) || quotedNameAndEmailRegex.test(email);
    }
    function emailAddressValidate(textValue) {
        var parts = textValue.split(/[,;]/);
        for (var i = 0; i < parts.length; i++) {
            if (!internalEmailIsValid(parts[i].trim())) {
                return false;
            }
        }
        return true;
    }
    exports.emailAddressValidate = emailAddressValidate;
    function getCurrentLocale() {
        var localeService = Injector.resolve(KnownServices_1.ServiceNames.LocaleService);
        if (localeService) {
            return localeService.getCurrentLocale();
        }
    }
    exports.getCurrentLocale = getCurrentLocale;
    function getUserAgent() {
        return navigator.userAgent;
    }
    exports.getUserAgent = getUserAgent;
    function getEntryEspaceName() {
        return ApplicationInfo.getHomeModuleName();
    }
    exports.getEntryEspaceName = getEntryEspaceName;
    function getBookmarkableURL() {
        return window.location.href;
    }
    exports.getBookmarkableURL = getBookmarkableURL;
    function getOwnerURLPath() {
        return Navigation.buildApplicationRelativeUrl();
    }
    exports.getOwnerURLPath = getOwnerURLPath;
    function getUserId() {
        return RolesInfo.getUserId();
    }
    exports.getUserId = getUserId;
    function iif(condition, trueReturn, falseReturn) {
        return condition ? trueReturn : falseReturn;
    }
    exports.iif = iif;
});
//# sourceMappingURL=BuiltinFunctions.js.map;
